import React from 'react';
import * as classnames from 'classnames';

import './styles.scss';

const Button = ({
	text,
	type = 'submit',
	leftIcon,
	isLight,
	rightIcon,
	onClick
}) => {
	return (
		<button 
			type={type}
			className={
				classnames('button', {
					'button--isLight': isLight,
					'button--isIcon': leftIcon && !text,
					'button--isText': !leftIcon && text,
					'button--isRightIcon': rightIcon,
				})
			}
			onClick={onClick}
		>
			{leftIcon}
			{text && <span className="button__text">{text}</span>}
			{rightIcon}
		</button>
	);
};

export default Button;
